module.exports = __webpack_public_path__ + "assets/img/payment.ad0d791d.svg";